import { render, staticRenderFns } from "./FormularioNavidad.vue?vue&type=template&id=2f51548c&scoped=true&"
import script from "./FormularioNavidad.vue?vue&type=script&lang=ts&"
export * from "./FormularioNavidad.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioNavidad.vue?vue&type=style&index=0&id=2f51548c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51548c",
  null
  
)

export default component.exports